import { z } from "zod";
import { NotificationsResponseSchema } from "./components/notifications/constants";
import { StandardResponseSchema, type StandardResponse } from "@/helpers/types";

export type Notification = z.infer<typeof NotificationsResponseSchema>["notifications"][0];

export type NotificationConfig = Notification["config"];

export enum NotificationChannelType {
  SLACK = "slack",
}

export interface NotificationChannel {
  id: string;
  name: string;
  type: string;
  [key: string]: unknown;
}

export const addNotificationChannelSchema = z.object({
  name: z.string().min(1, "Name is required"),
  type: z.nativeEnum(NotificationChannelType),
  webhook_url: z.string().url("Please enter a valid URL"),
});

export type AddNotificationChannelFormData = z.infer<typeof addNotificationChannelSchema>;

export interface AddNotificationChannelProps {
  toggleAddNotificationChannel: () => void;
}

export interface NotificationChannelsProps {
  toggleAddNotificationChannel: () => void;
}

export interface NoChannelsProps {
  toggleAddNotificationChannel: () => void;
}

// Slack webhook request
export interface SlackWebhookRequest {
  webhook_url: string;
  name: string;
}

// Slack webhook response - uses StandardResponseSchema
export const SlackWebhookResponseSchema = StandardResponseSchema;
export type SlackWebhookResponse = StandardResponse;

// Company register request
export interface CompanyRegisterRequest {
  company: string;
  email: string;
  name: string;
  password: string;
  newsletter: boolean;
  source_insight: string;
  // "Tell us about your setup" answers; stored in the user's attributes JSON.
  primary_warehouse?: string;
  role?: string;
}

// Company register response schema
export const CompanyRegisterResponseSchema = StandardResponseSchema;
export type CompanyRegisterResponse = StandardResponse;
